// extracted by mini-css-extract-plugin
module.exports = {"container":"_1-dJ30Q","button_content":"a8t8zBs","qr_code_content":"_3DB_4Qe","text_area":"_29e2rQt"};